/**
 * @param dealType Тип сделки (sale|rent|rentDaily)
 * @param realtyType Тип объекта недвижимости (apartments|lands|commercials)
 */

import ApiClient from './ApiClient';

export default class UserApi extends ApiClient {
  profile (token) {
    return this.get(`profile`, {}, token);
  }

  // Избранное
  favorites (userId, dealType, realtyType, filter, token) {
    return this.get(`users/${userId}/favorites/${dealType}/${realtyType}`, filter, token);
  }

  favoritesAdd (userId, dealType, realtyType, realtyId) {
    return this.post(`users/${userId}/favorites/${dealType}/${realtyType}/${realtyId}`);
  }

  favoritesRemove (userId, dealType, realtyType, realtyId) {
    return this.delete(`users/${userId}/favorites/${dealType}/${realtyType}/${realtyId}`);
  }

  favoritesDeleteAll (userId) {
    return this.delete(`users/${userId}/favorites`);
  }

  /**
   * @param userID
   * @param favorites json с избранным [
   * {'section': 'sale_apartments', 'id': 5684308, 'status': 'added', 'timestamp': 1467370555},
   * ...]
   * @returns {*}
   */
  favoritesSync (userID, favorites) {
    return this.put(`users/${userID}/favorites/sync`, { favorites });
  }

  // Комментарии к объектам нежвижимости
  commentCreate (comment) {
    const {userId, dealType, realtyType, realtyId, text, isPublic} = comment;

    return this.post(`users/${userId}/comments/${dealType}/${realtyType}/${realtyId}`, { text, isPublic });
  }

  commentUpdate (comment) {
    const {userId, id, text, isPublic} = comment;

    return this.put(`users/${userId}/comments/${id}`, { text, isPublic });
  }

  commentRemove (comment) {
    const {userId, id} = comment;

    return this.delete(`users/${userId}/comments/${id}`);
  }

  // Сохраненные поиски
  filters (userId, token) {
    return this.get(`users/${userId}/filters?v=2`, {}, token);
  }

  filtersAdd (userId, data) {
    return this.post(`users/${userId}/filters`, data);
  }

  // на новые объекты
  subscribeOnFilter (dealType, realtyType, data) {
    return this.post(`${dealType}/${realtyType}/subscribeOnFilter`, data);
  }
  // на существующие
  subscribeFilter (userId, filterId, token) {
    return this.patch(`users/${userId}/filters/${filterId}/subscribe`, token);
  }
  // на существующие
  unsubscribeFilter (userId, filterId, token) {
    return this.patch(`users/${userId}/filters/${filterId}/unsubscribe`, token);
  }

  deleteFilter (userId, filterId, token) {
    return this.delete(`users/${userId}/filters/${filterId}`, token);
  }
}



// WEBPACK FOOTER //
// ./src/api/UserApi.js